import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import ACL_RELATIONSHIPS from "acl-relationships";
import useAuthorized from "hooks/useAuthorized";
import MetaLeadsEventForm from "routes/meta_leads_events/components/MetaLeadsEventForm";

const MetaLeadsEventModal = ({ event, open, onOpenChange, onSuccess }) => {
  const [internalOpen, setInternalOpen] = useState(false);
  const isControlled = open !== undefined;
  const actualOpen = isControlled ? open : internalOpen;
  const setOpen = isControlled ? onOpenChange : setInternalOpen;

  const canCreate = useAuthorized([ACL_RELATIONSHIPS.metaLeadsEvent.create]);

  const handleSuccess = () => {
    setOpen(false);
    onSuccess?.();
  };

  const header = `${event ? "Edit" : "New"} Meta Leads Event`;

  return (
    <Dialog open={actualOpen} onOpenChange={setOpen}>
      {!isControlled && canCreate && (
        <DialogTrigger render={<Button size="sm">{header}</Button>} />
      )}
      <DialogContent>
        <DialogTitle>{header}</DialogTitle>
        {actualOpen && (
          <MetaLeadsEventForm event={event} onSuccess={handleSuccess} />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default MetaLeadsEventModal;
